import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";

const STATUSES = ["Pending Verification", "Approved for Display", "Hidden", "Removed", "Operator-Specific"];

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => http.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => { await http.put(`/admin/reviews/${id}`, patch); toast.success("Updated"); load(); };

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Review & Reputation</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Reviews</h1>
      <p className="text-[#6B665E] text-sm mb-8">Requests are never gated by expected sentiment. Operator-specific reviews are never misrepresented as another operator's. Entries marked SAMPLE are seeded examples, not real customer reviews.</p>
      <div className="space-y-3">
        {reviews.map((r) => (
          <Card key={r.id} className="p-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[#1A1918] font-medium text-sm">{r.name}</span>
                  {(r.sample || r.demo) && <span className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#C49A5A]/15 text-[#8a6a2e]">Sample</span>}
                  <span className="text-xs text-[#8A998C]">via {r.source}</span>
                  <span className="flex gap-0.5">{Array.from({ length: r.rating || 0 }).map((_, i) => <Star key={i} size={12} className="fill-[#C49A5A] text-[#C49A5A]" />)}</span>
                </div>
                <p className="text-[#6B665E] text-sm">{r.text}</p>
              </div>
              <div className="flex flex-col items-end gap-2 shrink-0">
                <select value={r.status} onChange={(e) => update(r.id, { status: e.target.value })} className="bg-[#F9F8F6] border border-[#E5E1D8] rounded-lg px-3 py-1.5 text-xs">
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
                <label className="flex items-center gap-1.5 text-xs text-[#6B665E]">
                  <input type="checkbox" checked={r.permission} onChange={(e) => update(r.id, { permission: e.target.checked })} /> Permission to display
                </label>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
